var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default"),_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.logout}},[_c('span',{staticClass:"icon-off"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }